import api from '@/api/api';
import { ISignInfo } from '@/models/account';
import { IResponseData, ResultDatas } from '@/models/common';
import { ISignupInfo, IResendEmailInfo } from '@/models/sign';
import { AxiosResponse } from 'axios';
import { ApiSign } from './';
import getApiResponse from '@/api/apiResponse';

export interface SigninParams {
  email: string;
  password: string;
  rememberMe?: boolean;
}

export const SignService = {
  async signin(params: SigninParams | null): Promise<ISignInfo | string> {
    if (params) {
      const res: AxiosResponse<IResponseData<ISignInfo>> = await api.post(ApiSign.SIGN_IN, params);
      return getApiResponse<ISignInfo>(res);
    } else {
      const res: AxiosResponse<IResponseData<string>> = await api.get(ApiSign.GET_TOKEN);
      return getApiResponse<string>(res);
    }
  },

  async withdraw(password: string): Promise<boolean> {
    const params = { password };
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiSign.WITHDRAW, params);
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },

  async signup(signupInfo: ISignupInfo): Promise<boolean> {
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiSign.SIGN_UP, signupInfo);
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },

  async checkPossibleEmail(email: string): Promise<string> {
    const params = { email };
    const res: AxiosResponse<IResponseData<string>> = await api.get(ApiSign.Check_Possible_Email, { params });
    return getApiResponse<string>(res);
  },

  async forgetPassword(email: string): Promise<boolean> {
    const params = { email };
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiSign.FORGOT_PASSWORD, params);
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },

  async resetPassword(email: string, password: string, code: string): Promise<boolean> {
    const params = { email, password, code };
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiSign.RESET_PASSWORD, params);
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },
  async confirmEmail(userId: string, code: string): Promise<boolean> {
    const params = { userId, code };
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiSign.CONFIRM_EMAIL, params);
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },
  async signout(): Promise<boolean> {
    const res: AxiosResponse<IResponseData<string>> = await api.get(ApiSign.SIGN_OUT);
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },

  async getToken(): Promise<ISignInfo | string> {
    const res: AxiosResponse<IResponseData<ISignInfo | string>> = await api.get(ApiSign.GET_TOKEN);
    return getApiResponse<ISignInfo | string>(res);
  },

  async changePassword(oldPassword: string, newPassword: string): Promise<boolean> {
    const params = { newPassword, oldPassword };
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiSign.CHANGE_PASSWORD, params);
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },

  async resendEmail(params: IResendEmailInfo): Promise<boolean> {
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiSign.RESEND_EMAIL, params);
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },
};

export default SignService;
